export default __webpack_public_path__ + "static/media/NFO_PostLogin_Diversified_Fund_Hero_Mobile.a4f517d3.jpg";